export const LVL_EDU_ASPIRANT = 6;
export const LVL_EDU_ADUNKT = 7;
export const LVL_EDU_ORDINAT = 8;
export const LVL_EDU_ASSIST = 9;
export const LVL_EDU_INTER = 22;
export const LVL_EDU_SPO_SREDN_ZVENO = 2;
export const LVL_EDU_SPO_KVALIF = 1;
